import React, { useEffect } from 'react';
import { withLocalize } from "react-localize-redux";
import { List, CheckList, Button, Modal, Toast } from 'antd-mobile';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { removeToken } from '../redux/actions';
import { useDispatch } from 'react-redux';
import ajaxService from '../services/ajax-service';

const Drawar = ({ translate, activeLanguage, setActiveLanguage }) => {

    const [login, setLogin] = useAuth()
    const history = useHistory();
    const dispatch = useDispatch();
    const router = useHistory();

    const logoutUser = async () => {

        let response = await ajaxService.post('logout');

        if (response) {
            dispatch(removeToken());
            setLogin(false);
            localStorage.removeItem('isLoggedIn');
            router.push({ pathname: '/home' })
        }
    }

    const renderAuth = () => {
        if (login) {
            return (
                <>
                    <List.Item onClick={() => history.push('/masjid-list')}>{translate('masajid')}</List.Item>
                    <List.Item onClick={() => logoutUser()}>{translate('logout')}</List.Item>
                </>
            );
        } else {
            return (
                <>
                    <List.Item onClick={() => history.push('/login')}>{translate('login')}</List.Item>
                    <List.Item onClick={() => history.push('/register')}>{translate('register')}</List.Item>
                </>
            );
        }
    }

    return (
        <>
            <List mode="card" header={translate('namaz_bajamat')}>
                <List.Item onClick={() => history.push('/home')}>{translate('home')}</List.Item>
            </List>

            <List mode="card" header={translate('account')}>
                {renderAuth()}
            </List>

            <List mode="card" defaultValue={activeLanguage.code} header={translate('language')}  >
                <List.Item onClick={() => setActiveLanguage('en')} >English</List.Item>
                <List.Item onClick={() => setActiveLanguage('ur')}>اردو</List.Item>
            </List>
        </>
    );

}

export default withLocalize(Drawar);